import { BRAND } from "themes";

const motion = {
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none",
  },
};

export const formStyles = {
  card: {
    backgroundColor: "#fff",
    border: `1px solid ${BRAND.border}`,
    borderRadius: "22px",
    padding: { xs: "16px", md: "22px" },
    boxShadow: "0 10px 30px -18px rgba(27, 19, 64, 0.22)",
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      backgroundColor: "#fff",
      "& fieldset": { borderColor: BRAND.border },
      "&:hover fieldset": { borderColor: "#DDD8EE" },
      "&.Mui-focused fieldset": { borderColor: BRAND.primary, borderWidth: 1 },
      "&.Mui-disabled": { backgroundColor: BRAND.track },
    },
    "& .MuiInputLabel-root": {
      color: "#5C5870",
      fontWeight: 500,
    },
    "& .MuiInputLabel-root.Mui-focused": { color: BRAND.primary },
    "& .MuiFormHelperText-root": { marginLeft: 0 },
    "& .MuiSelect-icon": { color: "#5C5870" },
  },
  section: {
    "& + &": {
      marginTop: "22px",
      paddingTop: "18px",
      borderTop: `1px solid ${BRAND.border}`,
    },
  },
  sectionTitle: {
    marginBottom: "14px",
    color: BRAND.ink,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: "22px",
    letterSpacing: "-0.02em",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "1fr 1fr 1fr" },
    gap: "16px",
  },
  prefix: {
    color: "#5C5870",
    fontWeight: 600,
    fontSize: 14,
  },
  adornmentButton: {
    color: BRAND.primary,
  },
  rupee: {
    color: BRAND.primary,
    fontSize: 18,
  },
  uploadField: {
    cursor: "pointer",
    "& input": { cursor: "pointer" },
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "22px",
    paddingTop: "18px",
    borderTop: `1px solid ${BRAND.border}`,
  },
  photoRow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "22px",
    paddingBottom: "18px",
    borderBottom: `1px solid ${BRAND.border}`,
  },
  photoButton: {
    margin: 0,
    padding: 0,
    border: 0,
    background: "transparent",
    cursor: "pointer",
    borderRadius: "50%",
    "&:focus-visible": {
      outline: `2px solid ${BRAND.primary}`,
      outlineOffset: 3,
    },
  },
  photo: {
    width: 72,
    height: 72,
    borderRadius: "50%",
    objectFit: "cover" as const,
    display: "block",
    boxShadow: "0 0 0 4px #EDE9FE",
  },
  photoEmpty: {
    width: 72,
    height: 72,
    borderRadius: "50%",
    display: "grid",
    placeItems: "center",
    color: BRAND.primary,
    backgroundColor: "#EDE9FE",
    "& .MuiSvgIcon-root": { fontSize: 28 },
  },
  photoLabel: {
    color: BRAND.ink,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: "22px",
    letterSpacing: "-0.02em",
  },
  textAction: {
    minWidth: 0,
    marginTop: "2px",
    padding: "4px 0",
    color: BRAND.primary,
    fontWeight: 600,
    fontSize: 14,
    textTransform: "none" as const,
    "&:hover": { backgroundColor: "transparent", color: BRAND.primaryDark },
  },
  addVehicle: {
    height: 53,
    alignSelf: "flex-end",
    borderRadius: "12px",
    boxShadow: "none",
    textTransform: "none" as const,
    fontWeight: 600,
    fontSize: 14,
    color: BRAND.ink,
    borderColor: BRAND.border,
    backgroundColor: "#fff",
    "&:hover": {
      borderColor: BRAND.border,
      backgroundColor: "#F7F5FF",
    },
  },
  vehicleList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginTop: "16px",
  },
  vehicleRow: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr auto", sm: "minmax(0, 1.2fr) minmax(0, 1.2fr) auto auto" },
    gap: "12px",
    alignItems: "center",
    padding: "12px 14px",
    borderRadius: "16px",
    backgroundColor: BRAND.track,
  },
  vehicleLabel: {
    color: "#5C5870",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "16px",
    letterSpacing: "0.04em",
    textTransform: "uppercase" as const,
  },
  vehicleValue: {
    marginTop: "2px",
    color: BRAND.ink,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "20px",
  },
  typePill: {
    justifySelf: "start",
    padding: "4px 10px",
    borderRadius: "999px",
    backgroundColor: "#EDE9FE",
    color: BRAND.primary,
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "16px",
  },
  removeVehicle: {
    width: 34,
    height: 34,
    borderRadius: "10px",
    border: `1px solid ${BRAND.border}`,
    color: "#B42318",
    backgroundColor: "#fff",
    "&:hover": { backgroundColor: "#FDECEC" },
  },
  submit: {
    height: 40,
    padding: "6px 16px",
    borderRadius: "12px",
    boxShadow: "none",
    textTransform: "none" as const,
    fontWeight: 600,
    fontSize: 14,
    backgroundColor: BRAND.primary,
    transition: "background-color 200ms ease",
    ...motion,
    "&:hover": {
      boxShadow: "none",
      backgroundColor: BRAND.primaryDark,
    },
    "&.Mui-disabled": {
      backgroundColor: "#D9D0F7",
      color: "#fff",
    },
    "&:focus-visible": {
      outline: `2px solid ${BRAND.primary}`,
      outlineOffset: 2,
    },
  },
};
